import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import caretaker from './modules/caretaker'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({
    storage: localStorage,
  })],
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    caretaker
  }
})
